import parser, { Element } from "html-react-parser";
import React from "react";
import { CloseButton } from "scmp-sdk/components/acquisition-popup-container/display/popups/common/close-button";
import type { MyNews } from "scmp-sdk/components/acquisition-popup-container/display/popups/my-news/types";
import { PopupBackdrop } from "scmp-sdk/components/acquisition-popup-container/display/styles";
import type { PopupProps } from "scmp-sdk/components/acquisition-popup-container/types";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { Modal } from "scmp-sdk/components/modal";

import CheckedIcon from "./checked.svg";
import {
  Container,
  ContentContainer,
  Description,
  DownloadLink,
  StyledRedirectButton,
  Title,
} from "./styles";

export type Props = PopupProps<{
  config: MyNews["completion"];
}>;

export const MyNewsCompletionPopup: React.FunctionComponent<Props> = ({
  config,
  modalContainerReference,
  onClose,
}) => {
  const { currentRoute } = useSdkContext();

  const isMyNewsIndexPage = currentRoute.toLowerCase() === "mynews";

  const computedButtonText = () =>
    isMyNewsIndexPage ? config.button.inMyNewsText : config.button.otherPageText;

  return (
    <Modal
      BackdropComponent={PopupBackdrop}
      container={modalContainerReference?.current}
      fadeTimeout={400}
      open={true}
    >
      <Container>
        <CloseButton
          onClose={() => {
            onClose();
          }}
        />
        <ContentContainer>
          <CheckedIcon />
          <Title dangerouslySetInnerHTML={{ __html: config.headline }} />
          <Description>
            {parser(config.description, {
              replace: domNode => {
                if (domNode instanceof Element && domNode.name === "download-link") {
                  return (
                    <DownloadLink
                      onClick={() => {
                        window.open("https://scmp.onelink.me/3586748601/aalocqf2", "_blank");
                      }}
                    >
                      download
                    </DownloadLink>
                  );
                }
                return domNode;
              },
            })}
          </Description>
          <StyledRedirectButton
            dangerouslySetInnerHTML={{ __html: computedButtonText() }}
            onClick={() => {
              onClose();
            }}
            url="/mynews"
          />
        </ContentContainer>
      </Container>
    </Modal>
  );
};

MyNewsCompletionPopup.displayName = "MyNewsCompletionPopup";
